import type {
  ResolvedShellTheme,
  ShellThemePreference,
} from "./theme-preferences";

type DocumentLike = Pick<Document, "documentElement">;

type ThemeDomSources = {
  documentRef?: DocumentLike;
};

export const applyThemeToDocument = (
  preference: ShellThemePreference,
  resolvedTheme: ResolvedShellTheme,
  sources: ThemeDomSources = {},
) => {
  const documentRef = sources.documentRef ?? globalThis.document;

  if (!documentRef) {
    return;
  }

  const root = documentRef.documentElement;

  root.classList.toggle("dark", resolvedTheme === "dark");
  root.setAttribute("data-theme", resolvedTheme);
  root.setAttribute("data-theme-preference", preference);
  root.style.colorScheme = resolvedTheme;
};
